// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__u9T14","footerInner":"style_footerInner__1pMBk","logo":"style_logo__3kX_M"};